import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { environment } from 'environments/environment';

/**
 * El Dashboard se dio de baja (TELE-829): quien llegue a `#/dashboard` o a sus rutas hijas (bookmarks, fe-home, el
 * `/web/home` de ClientSite, el botón de la página 404) termina en la Localización Instantánea nueva.
 * Se usa `replace` para que el botón "atrás" no vuelva a caer acá y rebote.
 */
@Injectable({
  providedIn: 'root'
})
export class DashboardRetiradoGuard implements CanActivate {

  canActivate(): boolean {
    window.location.replace(environment.appLocalizacionInstantanea);
    return false;
  }

}
